// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyOutlinedSvg from "@fishx/icons-svg/es/asn/CopyOutlined";
import FishxIcon from '../components/FishxIcon';

var CopyOutlined = function CopyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyOutlinedSvg
  }));
};

CopyOutlined.displayName = 'CopyOutlined';
export default React.forwardRef(CopyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyOutlined.js
// module id = 2330
// module chunks = 0